import { render, staticRenderFns } from "./banner-fastvaluedeal.vue?vue&type=template&id=03c7ce52&scoped=true&"
import script from "./banner-fastvaluedeal.vue?vue&type=script&lang=js&"
export * from "./banner-fastvaluedeal.vue?vue&type=script&lang=js&"
import style0 from "./banner-fastvaluedeal.vue?vue&type=style&index=0&id=03c7ce52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c7ce52",
  null
  
)

export default component.exports